import { coworkingSubTypes } from '../../../browser/addform/scripts/enums/commercial-object-types';

export const getCoworkingSubTypes = () => {
  return coworkingSubTypes;
};
